export default __webpack_public_path__ + "static/media/UsedCars.f93f5002.webp";